import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { Tween, Easing } from '@tweenjs/tween.js';
import CardSystem from '../../Card/CardSystem';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import { showCardScoreEffect } from '../CardAnimationHelper';

interface ICardAnchorMetaData {
    system: CardSystem;
    sourceCard: BaseCard;
}

export class CardAnchor extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: ICardAnchorMetaData
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        showCardScoreEffect(meta.system.scene, meta.sourceCard);

        const tweenScale: Tween = this.getTween(transform.scale);

        tweenScale.to({ x: 0, y: 0 }, 300).easing(Easing.Back.In);

        yield* this.startTween(tweenScale);
    }
}
